import { render, staticRenderFns } from "./ActTtnsValue.vue?vue&type=template&id=6ca62ae4&"
import script from "./ActTtnsValue.vue?vue&type=script&lang=js&"
export * from "./ActTtnsValue.vue?vue&type=script&lang=js&"
import style0 from "./ActTtnsValue.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports